import React, { useEffect, useState } from "react";
import "./HomePage.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import GitHubIcon from "@material-ui/icons/GitHub";
import YouTubeIcon from "@material-ui/icons/YouTube";
import FacebookIcon from "@material-ui/icons/Facebook";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import InstagramIcon from "@material-ui/icons/Instagram";
import TwitterIcon from "@material-ui/icons/Twitter";
import { useSelector } from "react-redux";
import { getData } from "../features/dataSlice";
import { css } from "@emotion/core";
import RingLoader from "react-spinners/RingLoader";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

const override = css`
  display: block;
  margin: 0 auto;
  margin-left: -10%;
  border-color: red;
`;

const HomePage = () => {
  const [mobileView, setMobileView] = useState(window.innerWidth);
  let [color, setColor] = useState("#17D0D3");
  const data = useSelector(getData);
  const [showImage, setShowImage] = useState(false);

  useEffect(() => {
    const handleToggle = () => {
      setMobileView(window.innerWidth);
    };
    window.addEventListener("resize", handleToggle);
    return () => {
      window.removeEventListener("resize", handleToggle);
    };
  });

  useEffect(() => {
    document.title = "Ashwin's Portfolio - Home";
    setTimeout(() => {
      setShowImage(true);
    }, 3000);
    return () => {
      //
    };
  }, []);

  return (
    <div className="home">
      <Header />
      {data !== null ? (
        <>
          {mobileView > 800 ? (
            <div className="home-body-lg">
              <div className="home-info-lg">
                <h3 className="home-info-heading">
                  <span>{data.info1}</span>
                  {data.info2}
                </h3>
                <p className="home-info-text">{data.InfoP}</p>
                <div className="home-icons">
                  <a href={data.gitURL} target="_blank">
                    <GitHubIcon />
                  </a>
                  <a href={data.linkedInURL} target="_blank">
                    <LinkedInIcon />
                  </a>
                  <a href={data.twitterURL} target="_blank">
                    <TwitterIcon />
                  </a>
                  <a href={data.fbURL} target="_blank">
                    <FacebookIcon />
                  </a>
                  <a href={data.youtubeURL} target="_blank">
                    <YouTubeIcon />
                  </a>
                  <a href={data.instaURL} target="_blank">
                    <InstagramIcon />
                  </a>
                </div>
                <a
                  href={data.resumeURL}
                  download="Ashwin-Resume.pdf"
                  target="_blank"
                >
                  <button className="download-button">Download CV</button>
                </a>
              </div>
              {!showImage ? (
                <SkeletonTheme color="#lightgray" highlightColor="dimgray">
                  <section>
                    <Skeleton
                      style={{ marginRight: "83px" }}
                      circle
                      height={"35vw"}
                      width={"35vw"}
                    />
                  </section>
                </SkeletonTheme>
              ) : (
                <img
                  loading="eager"
                  src={data.imageURL}
                  alt="Ashwin"
                  className="home-image"
                />
              )}
            </div>
          ) : (
            <div className="home-body-sm">
              <div className="home-info-sm">
                <h3 className="home-info-heading">
                  <span>{data.info1}</span>
                  {data.info2}
                </h3>
                <p className="home-info-text">{data.InfoP}</p>
                <div className="home-icons">
                  <a href={data.gitURL} target="_blank">
                    <GitHubIcon />
                  </a>
                  <a href={data.linkedInURL} target="_blank">
                    <LinkedInIcon />
                  </a>
                  <a href={data.twitterURL} target="_blank">
                    <TwitterIcon />
                  </a>
                  <a href={data.fbURL} target="_blank">
                    <FacebookIcon />
                  </a>
                  <a href={data.youtubeURL} target="_blank">
                    <YouTubeIcon />
                  </a>
                  <a href={data.instaURL} target="_blank">
                    <InstagramIcon />
                  </a>
                </div>
                <a href={data.resumeURL} download target="_blank">
                  <button className="download-button">Download CV</button>
                </a>
              </div>
              {!showImage ? (
                <SkeletonTheme color="#lightgray" highlightColor="dimgray">
                  <section>
                    <Skeleton
                      style={{ marginLeft: "auto" }}
                      circle
                      height={"70vw"}
                      width={"70vw"}
                    />
                  </section>
                </SkeletonTheme>
              ) : (
                <img
                  loading="eager"
                  src={data.imageURL}
                  alt="Ashwin"
                  className="home-image"
                />
              )}
            </div>
          )}
        </>
      ) : (
        <div className="sweet-loading">
          <RingLoader
            color={color}
            loading={data === null}
            css={override}
            size={150}
          />
        </div>
      )}

      <Footer />
    </div>
  );
};

export default HomePage;
